if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

/**
 * @class
 * @function ThemeHeader
 */
if (!customElements.get('theme-header')) {
  class ThemeHeader extends HTMLElement {
    constructor() {
      super();
      this.categories = null;
    }

    connectedCallback() {
      this.header_section = document.querySelector('.header-section');
      this.menu = this.querySelector('#mobile-menu');
      this.toggle = this.querySelector('.mobile-toggle-wrapper');

      document.addEventListener('keyup', (e) => {
        if (e.code && e.code.toUpperCase() === 'ESCAPE') {
          if (this.toggle) {
            this.toggle.removeAttribute('open');
            this.toggle.classList.remove('active');
          }
          document.body.classList.remove('overflow-hidden');
          this.closeAllMenuAccordions();
          // this.collapseCategories();
        }
      });

      if (this.classList.contains('header-sticky--active')) {
        document.body.classList.add('header-sticky--active');
      }

  if (this.toggle && this.toggle.querySelector('.mobile-toggle')) {
  this.toggle.querySelector('.mobile-toggle').addEventListener('click', (e) => {
    if (this.toggle.classList.contains('active')) {
      e.preventDefault();
      document.body.classList.remove('overflow-hidden');
      this.toggle.classList.remove('active');
      this.closeAnimation(this.toggle);
      this.closeAllMenuAccordions();
      this.collapseCategories();
    } else {
      document.body.classList.add('overflow-hidden');

      if (this.categories) {
        this.categories.classList.remove('collapsed');
        this.updateCategoriesIcon();
      }

      setTimeout(() => {
        this.toggle.classList.add('active');
      });
    }
  });
}

      window.addEventListener('scroll', this.setStickyClass.bind(this), {
        passive: true
      });

      window.addEventListener('scroll', this.setHeaderOffset.bind(this), {
        passive: true
      });

      window.addEventListener('scroll', this.setHeaderHeight.bind(this), {
        passive: true
      });

      window.dispatchEvent(new Event('scroll'));

      if (document.querySelector('.announcement-bar-section')) {
        window.addEventListener('scroll', this.setAnnouncementHeight.bind(this), {
          passive: true
        });
        window.dispatchEvent(new Event('resize'));
      }

      setTimeout(() => {
        this.mobile_nav = document.querySelector('.header-mobile-navigation');

        if (this.mobile_nav && this.classList.contains('transparent--true')) {
          this.mobile_nav.classList.add('is-fixed');
        }
      }, 100);

      this.initMobileCategories();

      if (this.menu) {
        this.menu.querySelectorAll('details').forEach((details) => {
          details.addEventListener('toggle', this.onDetailsToggle.bind(this));
        });

        this.menu.querySelectorAll('.parent-link-back--button').forEach((button) => {
          button.addEventListener('click', this.onCloseButtonClick.bind(this));
        });
      }
    }

    initMobileCategories() {
      const categories = document.getElementById('mobileMenuCategories');
      const categoriesToggle = document.getElementById('mobileMenuCategoriesToggle');
      const categoriesMore = document.getElementById('mobileMenuCategoriesMore');

      this.categories = categories;

      if (categories && categoriesToggle) {
        categoriesToggle.addEventListener('click', () => {
          const isCollapsed = categories.classList.contains('collapsed');

          if (isCollapsed) {
            this.closeAllMenuAccordions();
            categories.classList.remove('collapsed');
          } else {
            categories.classList.add('collapsed');
          }

          this.updateCategoriesIcon();
        });
      }

      if (categories && categoriesMore) {
        categoriesMore.addEventListener('click', function () {
          categories.classList.toggle('show-all');
          categoriesMore.textContent = categories.classList.contains('show-all')
            ? 'Show Less'
            : 'Expand More';
        });
      }
    }

    updateCategoriesIcon() {
      if (!this.categories) return;
      const icon = this.categories.querySelector('.toggle-icon');
      if (icon) {
        icon.textContent = this.categories.classList.contains('collapsed') ? '+' : '−';
      }
    }

    collapseCategories() {
      if (!this.categories) return;
      this.categories.classList.add('collapsed');
      this.updateCategoriesIcon();
    }

    closeAllMenuAccordions() {
      if (!this.menu) return;

      this.menu.querySelectorAll('details[open]').forEach((item) => {
        item.classList.remove('menu-opening', 'submenu-card-open');
        item.removeAttribute('open');
      });
    }

    setStickyClass() {
      if (this.classList.contains('header-sticky--active')) {
        let offset = parseInt(this.getBoundingClientRect().top, 10) + document.documentElement.scrollTop;
        this.classList.toggle('is-sticky', window.scrollY >= offset && window.scrollY > 0);
      }
    }

    setAnnouncementHeight() {
      const a_bar = document.querySelector('.announcement-bar-section');
      if (!a_bar) return;

      let h = a_bar.clientHeight;
      document.documentElement.style.setProperty('--announcement-height', h + 'px');
    }

    setHeaderOffset() {
      if (!this.header_section) return;

      let h = this.header_section.getBoundingClientRect().top;
      document.documentElement.style.setProperty('--header-offset', h + 'px');
    }

    setHeaderHeight() {
      let h = this.clientHeight;
      document.documentElement.style.setProperty('--header-height', h + 'px');
    }

    onDetailsToggle(event) {
      const currentDetails = event.currentTarget;
      const parentList = currentDetails.closest('li')?.parentElement || currentDetails.parentElement;

      if (currentDetails.open) {
        this.collapseCategories();

        if (parentList) {
          const siblingDetails = parentList.querySelectorAll(':scope > li > details');

          siblingDetails.forEach((item) => {
            if (item !== currentDetails && item.open) {
              item.classList.remove('menu-opening', 'submenu-card-open');
              item.removeAttribute('open');

              item.querySelectorAll('details[open]').forEach((nested) => {
                nested.classList.remove('menu-opening', 'submenu-card-open');
                nested.removeAttribute('open');
              });
            }
          });
        }

        currentDetails.classList.add('menu-opening', 'submenu-card-open');
      } else {
        currentDetails.classList.remove('menu-opening', 'submenu-card-open');
      }
    }

    onCloseButtonClick(event) {
      event.preventDefault();
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }

    closeSubmenu(detailsElement) {
      if (!detailsElement) return;

      detailsElement.classList.remove('menu-opening');
      detailsElement.classList.remove('submenu-card-open');

      const nestedOpenItems = detailsElement.querySelectorAll('details[open]');
      nestedOpenItems.forEach((nestedItem) => {
        nestedItem.classList.remove('menu-opening');
        nestedItem.classList.remove('submenu-card-open');
        nestedItem.removeAttribute('open');
      });

      detailsElement.removeAttribute('open');
    }

    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 200) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
  }

  customElements.define('theme-header', ThemeHeader);
}

/**
 * @class
 * @function FullMenu
 */
if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();
      this.submenus = this.querySelectorAll('.thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu');
    }

    connectedCallback() {
      if (!this.submenus.length) {
        return;
      }

      const _this = this;

      document.fonts.ready.then(function () {
        window.addEventListener('resize', debounce(function () {
          _this.resizeSubMenus();
        }, 100));
      });
    }

    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        let sub_submenus = submenu.querySelectorAll(':scope > .menu-item-has-children > .sub-menu');

        sub_submenus.forEach((sub_submenu) => {
          let w = sub_submenu.offsetWidth;
          let l = sub_submenu.parentElement.getBoundingClientRect().left + sub_submenu.parentElement.offsetWidth;
          let total = w + l;

          if (total > window.innerWidth) {
            sub_submenu.parentElement.classList.add('left-submenu');
          } else if (sub_submenu.parentElement.classList.contains('left-submenu')) {
            sub_submenu.parentElement.classList.remove('left-submenu');
          }
        });
      });
    }
  }

  customElements.define('full-menu', FullMenu);
}